import { Group } from '@app/core/models';

export interface AcademicState {
  group_active: Group;
  period_id: number;
}

export const initialState: AcademicState = {
  group_active: undefined,
  period_id: undefined,
};
